import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import Button from "../custom/Button";
import { getAuthenticatedApps, authApp } from "../../services/api"; // Updated to include `authApp`
import { DataState } from "./../../context/DataProvider";
import { authenticateApp } from "../../utils/auth";
import { authApps } from "../../utils/constants";

// const openAuthPopup = (url, title, w, h) => {
//   const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
//   const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

//   const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
//   const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

//   const systemZoom = width / window.screen.availWidth;
//   const left = (width - w) / 2 / systemZoom + dualScreenLeft;
//   const top = (height - h) / 2 / systemZoom + dualScreenTop;

//   const newWindow = window.open(url, title,
//     `scrollbars=yes, width=${w / systemZoom}, height=${h / systemZoom}, top=${top}, left=${left}`);

//   if (window.focus) newWindow.focus();

//   return newWindow;
// };

// const authenticateApp = async (appName, botId, userGoogleId, onAuthSuccess, updateAuthApps) => {
//   try {
//     const response = await authApp(appName, botId, userGoogleId);
//     if (response.success){
//       updateAuthApps();
//       onAuthSuccess();
//       return;
//     }
//     console.log("response for auth:", response)
//     const popup = openAuthPopup(response.auth_url, 'Google Authentication', 600, 700);

//     const receiveMessage = (event) => {
//       console.log(event)
//       if (event.origin !== 'http://localhost:5000' && event.origin !== "https://devbackend-qo6z5qg44q-em.a.run.app") return;

//       const { status, appName, error } = event.data;

//       if (status === 'success') {
//         console.log(`Successfully authenticated ${appName}`);
//         updateAuthApps();
//         onAuthSuccess();  // Trigger app list refetch

//       } else {
//         console.error(`Failed to authenticate ${appName}: ${error}`);
//       }

//       window.removeEventListener('message', receiveMessage);
//     };

//     window.addEventListener('message', receiveMessage, false);

//   } catch (error) {
//     console.error("Error initiating authentication:", error);
//     alert("Failed to start authentication process. Please try again.");
//   }
// };

const TriggerModal = ({
  title,
  desc,
  isOpen,
  onClose,
  appsData,
  setSelectedOptions,
  selectedOptions,
  editOption,
}) => {
  const [localSelectedOption, setLocalSelectedOption] = useState(null);
  const [selectedFunctions, setSelectedFunctions] = useState([]);
  const [triggerPhrase, setTriggerPhrase] = useState("");
  const { userGoogleId } = DataState();

  useEffect(() => {
    setLocalSelectedOption(null);
    if (editOption) {
      setLocalSelectedOption(editOption);
      if (editOption.value === "when_i_message_the_assistant") {
        setTriggerPhrase(editOption?.triggerPhrase || "");
      } else if (editOption.selectedFunctions) {
        setSelectedFunctions([...editOption.selectedFunctions]);
      }
    }
  }, [editOption]);

  const handleOptionSelect = (option) => {
    setLocalSelectedOption(option);
    setTriggerPhrase(""); // Reset trigger phrase when selecting a different app
    setSelectedFunctions([]); // Reset functions if selecting a different app
  };

  const handleFunctionSelect = (func) => {
    setSelectedFunctions((prev) =>
      prev.includes(func) ? prev.filter((f) => f !== func) : [...prev, func]
    );
  };

  const handleConfirm = async () => {
    if (localSelectedOption) {
      let functionsToSave = selectedFunctions;
      console.log("Local selected option:", localSelectedOption);

      // If no functions are selected, select all functions by default
      if (localSelectedOption.functions && selectedFunctions.length === 0) {
        functionsToSave = [...localSelectedOption.functions];
      }

      const optionToSave =
        localSelectedOption.value === "when_i_message_the_assistant"
          ? { ...localSelectedOption, triggerPhrase }
          : { ...localSelectedOption, selectedFunctions: functionsToSave };

      const updateAuthApps = () => {
        setSelectedOptions((prev) => {
          if (editOption) {
            return prev.map((item) =>
              item.id === editOption.id ? optionToSave : item
            );
          }
          return [...prev, optionToSave];
        });
      };

      if (authApps.includes(localSelectedOption.value)) {
        await authenticateApp(
          localSelectedOption.value,
          userGoogleId,
          closeModal,
          updateAuthApps
        );
      } else {
        updateAuthApps();
        closeModal();
      }

      // Reset states and close modal
      // setLocalSelectedOption(null);
      // setTriggerPhrase("");
      // setSelectedFunctions([]);
      // onClose();
    }
  };

  const closeModal = () => {
    setLocalSelectedOption(null);
    setSelectedFunctions([]);
    setTriggerPhrase("");
    onClose();
  };

  return (
    <>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-[110] bg-black bg-opacity-50"
            onClick={closeModal}
          ></div>
          <div className="fixed top-[50%] z-[120] left-[50%] p-8 rounded-lg bg-2 border br-1 shadow-2xl translate-x-[-50%] translate-y-[-50%] flex flex-col w-[864px] max-w-[calc(100vw-2rem)] max-h-[min(680px,calc(100vh-2rem))] py-6 text-p-text min-h-96">
            <div className="flex flex-col gap-6 flex-1 min-h-0">
              <header className="flex items-center justify-between">
                <div className="flex flex-col gap-1">
                  <h2 className="text-lg font-semibold p-text">{title}</h2>
                  <p className="text-sm text-s-text">{desc}</p>
                </div>
                <button
                  onClick={closeModal}
                  type="button"
                  className="rounded-[3px] text-md font-semibold transition-colors duration-150 ease-in-out disabled:cursor-not-allowed text-xl"
                >
                  <IoMdClose />
                </button>
              </header>

              <div className="flex flex-col gap-4 flex-1 min-h-0 overflow-y-auto">
                {!localSelectedOption?.functions &&
                  localSelectedOption?.value !==
                    "when_i_message_the_assistant" && (
                    <div className="flex flex-wrap gap-4 mb-4">
                      {appsData.map((item) => (
                        <button
                          type="button"
                          onClick={() => handleOptionSelect(item)}
                          key={item.id}
                          className={`flex border border-zinc-400 rounded-full items-center gap-2 text-md font-semibold transition-colors duration-150 ease-in-out align-middle text-left px-3 py-2 ${
                            localSelectedOption?.id === item.id
                              ? "bg-zinc-200 text-zinc-800"
                              : selectedOptions.some(
                                  (opt) => opt.id === item.id
                                )
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                          }`}
                          disabled={
                            selectedOptions.some((opt) => opt.id === item.id) &&
                            !editOption
                          }
                        >
                          <div className="bg-zinc-200 rounded-lg p-1">
                            <img
                              alt={item.label}
                              src={item.image}
                              className="h-7 w-7"
                            />
                          </div>
                          <div className="text-s-text text-lg ml-1">{item.label}</div>
                        </button>
                      ))}
                    </div>
                  )}

                {localSelectedOption?.value ===
                  "when_i_message_the_assistant" && (
                  <div className="flex flex-col gap-2">
                    <label className="text-sm ">
                      Enter the trigger phrase:
                    </label>
                    <input
                      type="text"
                      value={triggerPhrase}
                      onChange={(e) => setTriggerPhrase(e.target.value)}
                      className="p-2 rounded-md bg-1 outline-none"
                    />
                  </div>
                )}

                {/* Show functions if they exist for the selected app */}
                {localSelectedOption && localSelectedOption?.functions && (
                  <div className="flex flex-col gap-2">
                    <label className="text-sm ">Select functions</label>
                    <div className="flex flex-wrap gap-2">
                      {localSelectedOption.functions.map((func) => (
                        <button
                          key={func}
                          className={`px-3 py-1.5 rounded-full text-sm text-s-text transition-all duration-200 ${
                            selectedFunctions.includes(func)
                              ? "bg-zinc-100 text-zinc-800 hover:bg-zinc-300"
                              : "bg-zinc-800 text-zinc-100 hover:bg-zinc-700 hover:text-zinc-100"
                          }`}
                          onClick={() => {
                            if (selectedFunctions.includes(func)) {
                              // Deselect the function
                              setSelectedFunctions(
                                selectedFunctions.filter((f) => f !== func)
                              );
                            } else {
                              // Select the function
                              setSelectedFunctions([
                                ...selectedFunctions,
                                func,
                              ]);
                            }
                          }}
                        >
                          <span className="text-sm">
                            {func.charAt(0).toUpperCase() +
                              func.slice(1).toLowerCase()}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Show confirm button only when there is a selection */}
              {(localSelectedOption?.functions ||
                localSelectedOption?.value === "when_i_message_the_assistant" ||
                localSelectedOption) && (
                <footer className="flex justify-end gap-4">
                  <div className="w-28">
                    <Button onClick={handleConfirm}>Confirm</Button>
                  </div>
                </footer>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TriggerModal;
